<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />
    <div :class="getInterventionAreaClass()">
      <!--Intervention section-->
      <div>
        <br aria-hidden="true" />
        <h1>{{ LG("IV_headingIntervention") }}</h1>
        <p class="h2" v-html="LG(getInterventionQuestion())"></p>
        <br aria-hidden="true" />

        <!--This is the new test layout to save space with square on right an shortened sentences-->
        <!--<div class="row" v-show="newLayout">
                    <div class="col-sm-5">
                        <div v-for="(choice, index) in getInterventionChoices()" :key="choice.text" class="bullet-text-size">
                            <div class="row">
                                <div class="col-sm-2 mr-2">
                                    <button class="radioCircle-button" disabled=true v-on:click="setCurrentSelection(index)"><b-img :src="getRadioButtonImage(index)" width="30" height="auto" alt=""></b-img></button>
                                </div>
                                <div class="col-sm-9">
                                    <p v-html="getFirstSentence(choice.text)"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-7 selected-text-area">
                        <p v-html="getSelectedText()"></p>
                    </div>
                </div>-->

        <!--Previous method took up too much real-estate in some levels-->
        <div>
          <br aria-hidden="true" />
          <div v-for="(choice, index) in getInterventionChoices()" :key="choice.text" class="bullet-text-size">
            <div class="float-left green-checkmark" aria-hidden="true" v-if="showGreenCheckmark(index)">
              <font-awesome-icon icon="check" />
            </div>
            <div class="float-left red-x" aria-hidden="true" v-if="showRedX(index)">
              &nbsp;
            </div>
            <div class="float-left blank-space" aria-hidden="true" v-if="showSpace(index)">
              &nbsp;
            </div>
            <div class="row">
              <div class="col-sm-1">
                <input type="radio" :id="'choix' + index" name="fav_language" :value="index" class="radioCircle-button" :disabled="isRadioButtonDisabled()" v-on:click="setCurrentSelection(index)" :aria-label="(showGreenCheckmark(index) ? 'La bonne réponse est :' : '') + LG(choice.text)" />
                <!-- <b-img :src="getRadioButtonImage(index)" width="30" height="auto" alt=""></b-img> -->
              </div>
              <div class="col-sm-11">
                <label :class="getChoiceParagraphClass(index)" :for="'choix' + index" v-html="LG(choice.text)" aria-hidden="true"></label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br aria-hidden="true" />
      <div class="centered-element" v-show="!showRetroactionSection()">
        <b-button class="funky-shape" v-on:click="onSubmitButtonClicked()" :disabled="isSubmitDisabled()">{{ getSubmitButtonLabel() }}</b-button>
      </div>

      <div v-show="showRetroactionSection()">
        <!--Retroaction section-->
        <div>
          <h1>{{ LG("IV_headingRetroaction") }}</h1>
          <br aria-hidden="true" />
          <!--<p v-html="getRetroaction()"></p>-->
          <div v-show="isVideoActive()">
            <div class="center-video">
              <VideoPlayer mediaId="" youtube="no" url="" id="vid0" ref="iVideoRef" width="640" height="360" minheight="600" message="HP_paragraph3"></VideoPlayer>
            </div>
          </div>
        </div>
        <div class="centered-element">
          <b-button class="funky-shape" v-on:click="onContinueButtonClicked()">{{ getContinueButtonLabel() }}</b-button>
        </div>
      </div>
    </div>
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <AudioPlayer id="sfxCorrect-id" ref="sfxCorrectRef" autoplay="no" :url="sfxCorrect" registered="no"></AudioPlayer>
    <div v-if="hasIntroAudio()">
      <AudioPlayer id="inter-intro-id" :url="getIntroAudio()" registered="yes"></AudioPlayer>
    </div>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
import VideoPlayer from "../components/VideoPlayer.vue";
import AudioPlayer from "../components/AudioPlayer.vue";

export default {
  components: {
    ProgressBars,
    VideoPlayer,
    AudioPlayer,
  },
  data() {
    return {
      areaName: this.$route.params.areaName,
      situationName: this.$route.params.situationName,

      // Arrays
      questions: [
        {
          id: "id-situation-1",
          question: "IV_S1_Question",
          audioUrl: "/audio/scene1/L'accueil des familles_024.mp3",
          choices: [
            {
              text: "IV_S1_Choice1",
              correct: false,
              //url: "/videos/scene1/Retro1.mp4",
              url: "https://content.jwplatform.com/videos/3fUditrP-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/3fUditrP-1280.jpg",
              mediaId: "3fUditrP",
              transcript: "/videos/scene1/Retro1.txt",
            },
            {
              text: "IV_S1_Choice2",
              correct: true,
              //url: "/videos/scene1/Retro2.mp4",
              url: "https://content.jwplatform.com/videos/1VjLXAR3-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/1VjLXAR3-1280.jpg",
              mediaId: "1VjLXAR3",
              transcript: "/videos/scene1/Retro2.txt",
            },
            {
              text: "IV_S1_Choice3",
              correct: false,
              //url: "/videos/scene1/Retro3.mp4",
              url: "https://content.jwplatform.com/videos/jjxz862R-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/jjxz862R-1280.jpg",
              mediaId: "jjxz862R",
              transcript: "/videos/scene1/Retro3.txt",
            },
          ],
        },
        {
          id: "id-situation-2",
          question: "IV_S2_Question",
          audioUrl: "/audio/scene2/L'écoute visible_020.mp3",
          choices: [
            {
              text: "IV_S2_Choice1",
              correct: false,
              //url: "/videos/scene2/Retro1.mp4",
              url: "https://content.jwplatform.com/videos/4mTBjg8p-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/4mTBjg8p-1280.jpg",
              mediaId: "4mTBjg8p",
              transcript: "/videos/scene2/Retro1.txt",
            },
            {
              text: "IV_S2_Choice2",
              correct: true,
              //url: "/videos/scene2/Retro2.mp4",
              url: "https://content.jwplatform.com/videos/DaxRDCGO-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/DaxRDCGO-1280.jpg",
              mediaId: "DaxRDCGO",
              transcript: "/videos/scene2/Retro2.txt",
            },
            {
              text: "IV_S2_Choice3",
              correct: false,
              //url: "/videos/scene2/Retro3.mp4",
              url: "https://content.jwplatform.com/videos/D8WA6aba-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/D8WA6aba-1280.jpg",
              mediaId: "D8WA6aba",
              transcript: "/videos/scene2/Retro3.txt",
            },
          ],
        },
        {
          id: "id-situation-3",
          question: "IV_S3_Question",
          audioUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_20.mp3",
          choices: [
            {
              text: "IV_S3_Choice1",
              correct: true,
              //url: "/videos/scene3/Retro1.mp4",
              url: "https://content.jwplatform.com/videos/wQKUchwD-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/wQKUchwD-1280.jpg",
              mediaId: "wQKUchwD",
              transcript: "/videos/scene3/Retro1.txt",
            },
            {
              text: "IV_S3_Choice2",
              correct: false,
              //url: "/videos/scene3/Retro2.mp4",
              url: "https://content.jwplatform.com/videos/oTDMsEPz-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/oTDMsEPz-1280.jpg",
              mediaId: "oTDMsEPz",
              transcript: "/videos/scene3/Retro2.txt",
            },
            {
              text: "IV_S3_Choice3",
              correct: false,
              //url: "/videos/scene3/Retro3.mp4",
              url: "https://content.jwplatform.com/videos/1DdisV97-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/1DdisV97-1280.jpg",
              mediaId: "1DdisV97",
              transcript: "/videos/scene3/Retro3.txt",
            },
          ],
        },
        {
          id: "id-situation-4",
          question: "IV_S4_Question",
          audioUrl: "/audio/scene4/Ici, je suis chez moi_020.mp3",
          choices: [
            {
              text: "IV_S4_Choice1",
              correct: false,
              //url: "/videos/scene4/Retro1.mp4",
              url: "https://content.jwplatform.com/videos/dCmpZFpj-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/dCmpZFpj-1280.jpg",
              mediaId: "dCmpZFpj",
              transcript: "/videos/scene4/Retro1.txt",
            },
            {
              text: "IV_S4_Choice2",
              correct: false,
              //url: "/videos/scene4/Retro2.mp4",
              url: "https://content.jwplatform.com/videos/ylx4VDTX-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/ylx4VDTX-1280.jpg",
              mediaId: "ylx4VDTX",
              transcript: "/videos/scene4/Retro2.txt",
            },
            {
              text: "IV_S4_Choice3",
              correct: true,
              //url: "/videos/scene4/Retro3.mp4",
              url: "https://content.jwplatform.com/videos/vniqrsir-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/vniqrsir-1280.jpg",
              mediaId: "vniqrsir",
              transcript: "/videos/scene4/Retro3.txt",
            },
          ],
        },
        {
          id: "id-situation-5",
          question: "IV_S5_Question",
          audioUrl: "/audio/scene5/Nature et découverte_020.mp3",
          choices: [
            {
              text: "IV_S5_Choice1",
              correct: false,
              //url: "/videos/scene5/Retro1.mp4",
              url: "https://content.jwplatform.com/videos/YNF1oP7c-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/YNF1oP7c-1280.jpg",
              mediaId: "YNF1oP7c",
              transcript: "/videos/scene5/Retro1.txt",
            },
            {
              text: "IV_S5_Choice2",
              correct: true,
              //url: "/videos/scene5/Retro2.mp4",
              url: "https://content.jwplatform.com/videos/kQeVmuUN-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/kQeVmuUN-1280.jpg",
              mediaId: "kQeVmuUN",
              transcript: "/videos/scene5/Retro2.txt",
            },
            {
              text: "IV_S5_Choice3",
              correct: false,
              //url: "/videos/scene5/Retro3.mp4",
              url: "https://content.jwplatform.com/videos/MHkKlv1b-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/MHkKlv1b-1280.jpg",
              mediaId: "MHkKlv1b",
              transcript: "/videos/scene5/Retro3.txt",
            },
          ],
        },
        {
          id: "id-situation-6",
          question: "IV_S6_Question",
          audioUrl: "/audio/scene6/Un environnement riche_020.mp3",
          choices: [
            {
              text: "IV_S6_Choice1",
              correct: false,
              //url: "/videos/scene6/Retro1.mp4",
              url: "https://content.jwplatform.com/videos/xtDYKvKH-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/xtDYKvKH-1280.jpg",
              mediaId: "xtDYKvKH",
              transcript: "/videos/scene6/Retro1.txt",
            },
            {
              text: "IV_S6_Choice2",
              correct: false,
              //url: "/videos/scene6/Retro2.mp4",
              url: "https://content.jwplatform.com/videos/caYMdNjH-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/caYMdNjH-1280.jpg",
              mediaId: "caYMdNjH",
              transcript: "/videos/scene6/Retro2.txt",
            },
            {
              text: "IV_S6_Choice3",
              correct: true,
              //url: "/videos/scene6/Retro3.mp4",
              url: "https://content.jwplatform.com/videos/kzzsUmfK-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/kzzsUmfK-1280.jpg",
              mediaId: "kzzsUmfK",
              transcript: "/videos/scene6/Retro3.txt",
            },
          ],
        },
        {
          id: "id-situation-7",
          question: "IV_S7_Question",
          audioUrl: "/audio/scene7/Cultiver des saines habitudes de vie_020.mp3",
          choices: [
            {
              text: "IV_S7_Choice1",
              correct: false,
              //url: "/videos/scene7/Retro1.mp4",
              url: "https://content.jwplatform.com/videos/JitQAQih-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/JitQAQih-1280.jpg",
              mediaId: "JitQAQih",
              transcript: "/videos/scene7/Retro1.txt",
            },
            {
              text: "IV_S7_Choice2",
              correct: true,
              //url: "/videos/scene7/Retro2.mp4",
              url: "https://content.jwplatform.com/videos/67eW9bBy-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/67eW9bBy-1280.jpg",
              mediaId: "67eW9bBy",
              transcript: "/videos/scene7/Retro2.txt",
            },
            {
              text: "IV_S7_Choice3",
              correct: false,
              //url: "/videos/scene7/Retro3.mp4",
              url: "https://content.jwplatform.com/videos/87LiUd2H-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/87LiUd2H-1280.jpg",
              mediaId: "87LiUd2H",
              transcript: "/videos/scene7/Retro3.txt",
            },
          ],
        },
        {
          id: "id-situation-8",
          question: "IV_S8_Question",
          audioUrl: "/audio/scene8/On joue dehors_020.mp3",
          choices: [
            {
              text: "IV_S8_Choice1",
              correct: false,
              //url: "/videos/scene8/Retro1.mp4",
              url: "https://content.jwplatform.com/videos/NrOJBhhb-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/NrOJBhhb-1280.jpg",
              mediaId: "NrOJBhhb",
              transcript: "/videos/scene8/Retro1.txt",
            },
            {
              text: "IV_S8_Choice2",
              correct: true,
              //url: "/videos/scene8/Retro2.mp4",
              url: "https://content.jwplatform.com/videos/EMrysUoZ-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/EMrysUoZ-1280.jpg",
              mediaId: "EMrysUoZ",
              transcript: "/videos/scene8/Retro2.txt",
            },
            {
              text: "IV_S8_Choice3",
              correct: false,
              //url: "/videos/scene8/Retro3.mp4",
              url: "https://content.jwplatform.com/videos/t8odbnbS-O8RTBfsm.mp4",
              poster: "https://content.jwplatform.com/thumbs/t8odbnbS-1280.jpg",
              mediaId: "t8odbnbS",
              transcript: "/videos/scene8/Retro3.txt",
            },
          ],
        },
        {
          id: "id-situation-9",
          question: "IV_S9_Question",
          audioUrl: "/audio/scene9/MES1-5.mp3",
          choices: [
            {
              text: "IV_S9_Choice1",
              correct: false,
              //url: "/videos/scene8/Retro1.mp4",
              url: "https://cdn.jwplayer.com/videos/IZh9mH5V-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/IZh9mH5V-1280.jpg",
              mediaId: "IZh9mH5V",
              transcript: "/videos/scene9/Retro1.txt",
            },
            {
              text: "IV_S9_Choice2",
              correct: true,
              //url: "/videos/scene8/Retro2.mp4",
              url: "https://cdn.jwplayer.com/videos/3f4cr6qG-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/3f4cr6qG-1280.jpg",
              mediaId: "3f4cr6qG",
              transcript: "/videos/scene9/Retro2.txt",
            },
            {
              text: "IV_S9_Choice3",
              correct: false,
              //url: "/videos/scene8/Retro3.mp4",
              url: "https://cdn.jwplayer.com/videos/TsTD5RSA-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/TsTD5RSA-1280.jpg",
              mediaId: "TsTD5RSA",
              transcript: "/videos/scene9/Retro3.txt",
            },
          ],
        },
        {
          id: "id-situation-10",
          question: "IV_S10_Question",
          audioUrl: "/audio/scene10/MES2-5.mp3",
          choices: [
            {
              text: "IV_S10_Choice1",
              correct: false,
              url: "https://cdn.jwplayer.com/videos/FjpPxC3J-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/FjpPxC3J-1280.jpg",
              mediaId: "FjpPxC3J",
              transcript: "/videos/scene10/Retro1.txt",
            },
            {
              text: "IV_S10_Choice2",
              correct: false,
              url: "https://cdn.jwplayer.com/videos/SQnunEuA-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/SQnunEuA-1280.jpg",
              mediaId: "SQnunEuA",
              transcript: "/videos/scene10/Retro2.txt",
            },
            {
              text: "IV_S10_Choice3",
              correct: true,
              url: "https://cdn.jwplayer.com/videos/2kcQYgt1-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/2kcQYgt1-1280.jpg",
              mediaId: "2kcQYgt1",
              transcript: "/videos/scene10/Retro3.txt",
            },
          ],
        },
        {
          id: "id-situation-11",
          question: "IV_S11_Question",
          audioUrl: "/audio/scene11/MES3-5.mp3",
          choices: [
            {
              text: "IV_S11_Choice1",
              correct: false,
              url: "https://cdn.jwplayer.com/videos/P3m30PbA-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/P3m30PbA-1280.jpg",
              mediaId: "P3m30PbA",
              transcript: "/videos/scene11/Retro1.txt",
            },
            {
              text: "IV_S11_Choice2",
              correct: true,
              url: "https://cdn.jwplayer.com/videos/CNRFxDUx-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/CNRFxDUx-1280.jpg",
              mediaId: "CNRFxDUx",
              transcript: "/videos/scene11/Retro2.txt",
            },
            {
              text: "IV_S11_Choice3",
              correct: false,
              url: "https://cdn.jwplayer.com/videos/SpoBe1NH-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/SpoBe1NH-1280.jpg",
              mediaId: "SpoBe1NH",
              transcript: "/videos/scene11/Retro3.txt",
            },
          ],
        },
        {
          id: "id-situation-12",
          question: "IV_S12_Question",
          audioUrl: "/audio/scene12/MES4-5.mp3",
          choices: [
            {
              text: "IV_S12_Choice1",
              correct: false,
              url: "https://cdn.jwplayer.com/videos/KQ9fyyN3-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/KQ9fyyN3-1280.jpg",
              mediaId: "KQ9fyyN3",
              transcript: "/videos/scene12/Retro1.txt",
            },
            {
              text: "IV_S12_Choice2",
              correct: true,
              url: "https://cdn.jwplayer.com/videos/BsgjcIlo-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/BsgjcIlo-1280.jpg",
              mediaId: "BsgjcIlo",
              transcript: "/videos/scene12/Retro2.txt",
            },
            {
              text: "IV_S12_Choice3",
              correct: false,
              url: "https://cdn.jwplayer.com/videos/yfs2ISx1-O8RTBfsm.mp4",
              poster: "https://cdn.jwplayer.com/thumbs/yfs2ISx1-1280.jpg",
              mediaId: "yfs2ISx1",
              transcript: "/videos/scene12/Retro3.txt",
            },
          ],
        },
      ],

      // Audio
      sfxCorrect: "/audio/sfx/SFX_CollectStar.mp3",

      // Images
      radioButtonImage: require("@/assets/icons/circle.png"),
      radioButtonSelectedImage: require("@/assets/icons/circle_black.png"),

      // Variables
      //newLayout: false,
      showingRetroaction: false,
    };
  },
  computed: {},
  created() {
    this.setArea(this.areaName);
    this.setSituation(this.situationName);

    this.setCurrentSelection("-1");
  },
  methods: {
    isRadioButtonDisabled() {
      if (this.showRetroactionSection()) {
        return true;
      }
      return false;
    },
    showGreenCheckmark(index) {
      if (!this.showRetroactionSection()) {
        return false;
      }
      if (this.isChoiceCorrect(index)) {
        return true;
      }
      return false;
    },
    getChoiceParagraphClass(index) {
      if (this.showGreenCheckmark(index)) {
        return "highlight-correct-answer";
      } else {
        return "no-highlight-answer";
      }
    },
    showRedX(index) {
      if (!this.showRetroactionSection()) {
        return false;
      }
      if (this.getSelection() != index) {
        return false;
      }
      if (!this.isChoiceCorrect(index)) {
        return true;
      }
      return false;
    },
    showSpace(index) {
      if (!this.newVersion()) {
        return false;
      }
      if (!this.showRedX(index) && !this.showGreenCheckmark(index)) {
        return true;
      }
      return false;
    },
    showRetroactionSection() {
      if (!this.newVersion()) {
        return false;
      }
      if (!this.showingRetroaction) {
        return false;
      }
      return true;
    },
    getInterventionAreaClass() {
      if (this.newVersion()) {
        return "bg-select-intervention-area bg-popup-area-new";
      }
      return "bg-select-intervention-area";
    },
    getFirstSentence(text) {
      var fullText = this.LG(text);
      var sentences = fullText.split(".");
      var firstSentence = sentences[0];
      return firstSentence + "...";
    },
    getSelectedText() {
      var selection = Number(this.getSelection());
      if (selection == -1) {
        return "";
      }

      var sentence = this.LG(this.questions[this.getCurrentSituation()].choices[selection].text);
      var firstPeriod = sentence.indexOf(".");
      if (firstPeriod == -1) {
        return sentence;
      }

      return sentence.substring(firstPeriod + 1);
    },
    getSelection() {
      return this.$store.state.gamestate.currentSelection;
    },
    getSubmitButtonLabel() {
      return this.LG("G_submitButtonLabel");
    },
    isSubmitDisabled() {
      if (this.getSelection() == -1) {
        return true;
      }
      return false;
    },
    getCurrentSituation() {
      return this.$store.state.gamestate.situation;
    },
    getInterventionQuestion() {
      return this.questions[this.getCurrentSituation()].question;
    },
    getInterventionChoices() {
      return this.questions[this.getCurrentSituation()].choices;
    },
    getRetroaction() {
      if (this.getSelection() == -1) {
        return "";
      }
      return this.LG(this.questions[this.getCurrentSituation()].choices[this.getSelection()].retroaction);
    },
    isSelectionCorrect() {
      if (this.getSelection() == -1) {
        return false;
      }
      return this.questions[this.getCurrentSituation()].choices[this.getSelection()].correct;
    },
    isChoiceCorrect(index) {
      if (index == -1) {
        return false;
      }
      return this.questions[this.getCurrentSituation()].choices[index].correct;
    },
    onSubmitButtonClicked() {
      if (!this.newVersion()) {
        this.saveGameState();
        this.$router.push("/retroaction");
      } else {
        // Play "Correct" sound effect
        // TBD - this wrapper function doesn't work if called by an asynchronous function like a button click ( I think.. )
        //this.playAudioByRefName("sfxCorrectRef");
        if (this.isSelectionCorrect()) {
          var audioRef = this.$refs["sfxCorrectRef"];
          if (audioRef != null) {
            audioRef.playAudio();
          }
        }

        // 1/2 second delay before starting video
        setTimeout(() => this.PlayRetroactionVideo(), 700);
      }
    },
    setCurrentSelection(index) {
      this.$store.commit("setCurrentSelection", index);
    },
    getRadioButtonImage(index) {
      if (this.getSelection() == index) {
        return this.radioButtonSelectedImage;
      } else {
        return this.radioButtonImage;
      }
    },
    getAnswerImage(index) {
      var correct = this.questions[this.getCurrentSituation()].choices[index].correct;
      if (correct) {
        return this.radioButtonSelectedImage;
      } else {
        return this.radioButtonImage;
      }
    },
    hasIntroAudio() {
      if (this.getIntroAudio() == null) {
        return false;
      }
      return true;
    },
    getIntroAudio() {
      return this.questions[this.getCurrentSituation()].audioUrl;
    },

    // RETROACTION SECTION! ====================================
    getContinueButtonLabel() {
      return this.LG("G_continueLabel");
    },
    isVideoActive() {
      if (this.getSelection() != -1) {
        return true;
      }
      return false;
    },
    getVideo() {
      if (!this.isVideoActive()) {
        return "";
      }
      return this.questions[this.getCurrentSituation()].choices[this.getSelection()].url;
    },
    getVideoMediaId() {
      if (!this.isVideoActive()) {
        return "";
      }
      return this.questions[this.getCurrentSituation()].choices[this.getSelection()].mediaId;
    },
    getTranscript() {
      if (!this.isVideoActive()) {
        return null;
      }
      return this.questions[this.getCurrentSituation()].choices[this.getSelection()].transcript;
    },
    onContinueButtonClicked() {
      this.StopRetroactionVideo();

      this.$router.push(`/${this.areaName}/${this.situationName}/conclusion`);
    },
    PlayRetroactionVideo() {
      this.saveGameState();
      this.showingRetroaction = true;

      if (this.getSelection() == -1) {
        return;
      }
      if (this.$refs.iVideoRef != null) {
        this.pauseAllAudio();
        this.$refs.iVideoRef.PlayVideo(this.getVideoMediaId(), this.getTranscript());

        // if (this.$store.state.gamestate.muted) {
        //   this.$refs.iVideoRef.setMute(true);
        // } else {
        //   this.$refs.iVideoRef.setMute(false);
        // }
      }
    },
    StopRetroactionVideo() {
      if (this.$refs.iVideoRef != null) {
        this.$refs.iVideoRef.StopVideo();
      }
    },
  },
};
</script>
<style scoped>
.h2 {
  font-size: 18px;
  font-weight: 600;
}
label {
  cursor: pointer;
}
input[type="radio"] {
  border: 0px;
  width: 0;
  height: 0;
  cursor: pointer;
}
input[type="radio"]:after {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  top: -2px;
  left: -1px;
  position: relative;
  background-color: #ebebeb;
  content: "";
  display: inline-block;
  visibility: visible;
  border: 1px solid #85b61c;
}

input[type="radio"]:checked:after {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  top: -2px;
  left: -1px;
  position: relative;
  background-color: black;
  content: "";
  display: inline-block;
  visibility: visible;

  -webkit-box-shadow: inset 0px 0px 0px 7px #ebebeb;
  -moz-box-shadow: inset 0px 0px 0px 7px #ebebeb;
  box-shadow: inset 0px 0px 0px 7px #ebebeb;

  border: 1px solid #85b61c;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css?family=Poppins");

.bg-select-intervention-area {
  background-color: white;
  color: black;
  font-family: "Poppins";
  font-size: 17px;
  max-width: 1000px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  padding: 25px;
}

.radio-circle {
  padding-top: 10px;
}

.radioCircle-button {
  background-color: transparent;
  border: none;
  padding-top: 5px;
}

.bullet-text-size {
  font-size: 14px;
}

.no-highlight-answer {
  padding: 5px;
}

.highlight-correct-answer {
  border: 2px solid green;
  border-radius: 10px;
  padding: 5px;
}

.green-checkmark {
  width: 5px;
  font-size: 28px;
  color: green;
  padding-right: 15px;
}

.red-x {
  width: 5px;
  font-size: 28px;
  font-family: Arial;
  color: transparent;
  padding-right: 15px;
}

.blank-space {
  width: 5px;
  font-size: 28px;
  font-family: Arial;
  color: transparent;
  padding-right: 15px;
}

.selected-text-area {
  font-size: 14px;
  border: 1px solid white;
  border-radius: 8px;
  margin: -10px;
  padding: 15px;
}

.center-video {
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  color: black;
}
</style>
